import { useResource, useResourceRelationship } from 'datx-jsonapi-react';
import { FC, Fragment, ReactNode } from 'react';

import { NonPublicTicketCheck } from '@/components/ui/shared/overlays/NoTicketCheck/components/NonPublicTicketCheck';
import { queryThinEvent, queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';

import { NoTicketLoader } from './components/NoTicketLoader';

interface INoTicketCheckProps {
  eventId: string;
  children?: ReactNode;
}

export const NoTicketCheckLectureAbstract: FC<INoTicketCheckProps> = ({ eventId, children }) => {
  const { data: event, error: eventError } = useResource(queryThinEvent(eventId));

  const { data: eventConfiguration } = useResourceRelationship<EventConfiguration>(
    queryThinEventConfigurationRelationship(eventId)
  );

  const isPublic = eventConfiguration.lecturesAbstractPagePublic;

  if (!event && !eventError) return <NoTicketLoader />;

  if (isPublic) return <Fragment>{children}</Fragment>;

  return <NonPublicTicketCheck event={event}>{children}</NonPublicTicketCheck>;
};
